import { formatDate } from "@clipboard-health/date-time";
import { DialogContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import {
  formatValidityPeriod,
  generateScheduleTbTestPath,
  getMinimumTestDate,
  SCHEDULE_TB_TEST_SOURCE,
} from "../constants";
import { type TbTestType } from "../types";

interface InvalidTestErrorStepProps {
  requirementId: string;
  testType: TbTestType;
  onReset: () => void;
}

export function InvalidTestErrorStep(props: InvalidTestErrorStepProps) {
  const { requirementId, testType, onReset } = props;
  const history = useHistory();

  useLogEffect(APP_V2_USER_EVENTS.VIEWED_TB_TEST_GUIDED_UPLOAD_INVALID_TEST_ERROR_STEP, {
    requirementId,
    testType,
  });

  const formattedMinimumDate = formatDate(getMinimumTestDate(testType));

  return (
    <>
      <DialogContent>
        <Stack spacing={9} sx={{ alignItems: "center", textAlign: "center", paddingTop: 8 }}>
          <Illustration type="document-rejected" />

          <Stack spacing={5}>
            <Text variant="h3">Your TB test is invalid</Text>

            <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              Clipboard requires a TB test to be done within the last{" "}
              {formatValidityPeriod(testType)}. Upload one dated after {formattedMinimumDate}.
            </Text>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="vertical">
        <Button fullWidth size="large" variant="contained" onClick={onReset}>
          Update TB test
        </Button>
        <TextButton
          size="large"
          sx={{ display: "flex", marginX: "auto" }}
          onClick={() => {
            history.push(
              generateScheduleTbTestPath(requirementId, SCHEDULE_TB_TEST_SOURCE.INVALID_TEST_ERROR)
            );
          }}
        >
          Schedule a TB Test
        </TextButton>
      </DialogFooter>
    </>
  );
}
